export enum LineOfBusinessEnum {
  IME = 1,
  Pharmacy,
  Disability,
  HealthReview,
  ImpairmentRatingReview,
  WorkersComp
}

export enum ApContact {
  Required = 1,
  AtDiscretion,
  NotRequired,
  OnDenial
}

// Mirrors Stradix.Core/Enumerations/ReviewerLifecycleStatus.cs
export enum ReviewerLifecycleStatus {
  Onboarding = 1,
  NotReady,
  Invited,
  Active,
  Archived
}